import { enhancedRequest } from '../utils/request.js'

// 获取单词详情
const getWordInfo = (data) => enhancedRequest({
  url: `/api/v1/word/getWordInfo`,
  method: 'get',
  data
})

// 分页获取单词列表
const pageListenWords = (data) => enhancedRequest({
  url: `/api/v1/english/user/listen/pageListenWords`,
  method: 'get',
  data
})

export {
  getWordInfo,
  pageListenWords
}
